'use client'

import Link from 'next/link'
import * as React from 'react'

import { handleProgramaticScroll } from '@/_lib/utils'

export type MButtonNextLinkProps = React.ComponentProps<typeof Link> & {
	/** When true, same-path hash clicks use programmatic smooth scroll (header offset, hashchange). */
	hashScroll?: boolean
}

/**
 * Client-only `next/link` used inside server `MButton` when `hashScroll` is needed — RSC cannot pass
 * `onClick` into `Link`; this wrapper owns the handler.
 */
export const MButtonNextLink = React.forwardRef<HTMLAnchorElement, MButtonNextLinkProps>(
	function MButtonNextLink({ hashScroll, onClick, ...props }, ref) {
		const handleClick: React.MouseEventHandler<HTMLAnchorElement> | undefined =
			hashScroll ?
				e => {
					onClick?.(e)
					if (!e.defaultPrevented) {
						handleProgramaticScroll(e, false)
					}
				}
			:	onClick

		return <Link ref={ref} {...props} onClick={handleClick} />
	}
)
